module.exports = __webpack_public_path__ + "img/hovered-layer1.aebda026.png";